import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { CalendarCheck, Loader2 } from "lucide-react";

const when = (iso) => new Date(iso).toLocaleString(undefined, { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
const n = (x) => (x || 0).toLocaleString();

/* COMPLETED THIS WEEK — trucks and parts that became complete since this week's starting snapshot (his, 22 Oct). */
export function WeekCompleted({ stamp }) {
  const [w, setW] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    setError("");
    api.get("/catch-up/checklist/week").then(({ data }) => setW(data))
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || "Could not count this week"));
  }, [stamp]);

  if (error) return <div data-testid="week-completed-error" className="text-sm text-[#B01E28]">{error}</div>;
  if (!w) return <div className="text-sm text-slate-500 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" />Counting this week…</div>;
  const slipped = w.trucks.slipped_back + w.parts.slipped_back;
  return (
    <div data-testid="week-completed" className="rounded-lg border-2 border-emerald-200 bg-emerald-50/60 p-3 flex items-start gap-3">
      <CalendarCheck className="w-5 h-5 text-emerald-700 shrink-0 mt-0.5" />
      <div className="min-w-0 text-sm text-slate-700 space-y-1">
        <p>
          <span className="font-bold text-[#1F1F1F]">Completed this week:</span>{" "}
          <b data-testid="week-trucks-completed" className="text-emerald-700 tabular-nums">{n(w.trucks.became_complete)}</b> truck{w.trucks.became_complete === 1 ? "" : "s"} ·{" "}
          <b data-testid="week-parts-completed" className="text-emerald-700 tabular-nums">{n(w.parts.became_complete)}</b> part{w.parts.became_complete === 1 ? "" : "s"}
          {slipped > 0 && <span data-testid="week-slipped-back" className="text-slate-500"> · {n(slipped)} slipped back (complete at the start of the week, something is missing now)</span>}
        </p>
        <p data-testid="week-counted-from" className="text-[12px] text-slate-500">
          {w.first_reading
            ? <>This is the first reading this week, so the count starts now ({when(w.counted_from)}).</>
            : <>Counted from {when(w.counted_from)}{w.started_on_monday ? "" : " — the first time this list was opened this week, so anything finished earlier isn't in it"}.</>}
          {" "}Weeks start Monday, yard time.
          {w.last_week && <span data-testid="week-last-week"> Last week, between the two snapshots ({when(w.last_week.from)} → {when(w.last_week.until)}): {n(w.last_week.trucks)} trucks · {n(w.last_week.parts)} parts.</span>}
        </p>
      </div>
    </div>
  );
}
